import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class HealthcareServiceThreshold extends BackboneElement {
    static __className = 'HealthcareServiceThreshold';

    __objectStructure = {
        min: Number,
        max: Number,
        charge: Number,
        units: Number,
        procedureCodeOverride: String,
        maximumTimeAllowed: Number,
    };

    constructor(constructJson, className = 'HealthcareServiceThreshold') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
